// extracted by mini-css-extract-plugin
export default {"section":"VideoBanner_section__AL0xX","video":"VideoBanner_video__kK5lh","playIcon":"VideoBanner_playIcon__T8BiT","button":"VideoBanner_button__F7+U9"};